/**
 * Constants for Job Post Creation
 * 
 * Shared constants used across AddJobPostV3 components
 * These ensure consistency across the application
 */

/**
 * Pass Percentage Constants
 * Used for interview rounds and job alignment configuration
 * 
 * - DEFAULT_PASS_PERCENTAGE: Default value when creating new rounds (70%)
 * - MIN_PASS_PERCENTAGE: Minimum allowed pass percentage (60%)
 * - MAX_PASS_PERCENTAGE: Maximum allowed pass percentage (100%)
 */
export const DEFAULT_PASS_PERCENTAGE = 70;
export const MIN_PASS_PERCENTAGE = 60;
export const MAX_PASS_PERCENTAGE = 100;
